'use strict';

class ParticipantList {
  constructor($routeParams, eventService, reportService, I18N, Notification) {
    this.eventService = eventService;
    this.reportService = reportService;
    this.I18N = I18N;
    this.Notification = Notification;

    this.number = $routeParams.number;
  }

  $onInit() {
    this.event = {};
    this.confirmed = [];
    this.unconfirmed = [];

    this.sms = {
      group: 'ALL',
      message: null
    };

    this.loadEvent();
    this.loadConfirmed();
    this.loadUnconfirmed();
  }

  loadEvent() {
    this.eventService.getEvent(this.number)
      .then((resp) => {
        this.event = resp.data;
      });
  }

  loadConfirmed() {
    this.eventService.getConfirmedParticipants(this.number)
      .then((resp) => {
        this.confirmed = resp.data;
      })
      .catch((err) => {
        if (err.status === 404) {
          this.Notification.error(this.I18N.participant.notFound);
        }
      });
  }

  loadUnconfirmed() {
    this.eventService.getUnconfirmedParticipants(this.number)
      .then((resp) => {
        this.unconfirmed = resp.data;
      })
      .catch((err) => {
        if (err.status === 404) {
          this.Notification.error(this.I18N.participant.notFound);
        }
      });
  }

  sendSms() {
    this.eventService.sendSms(this.number, this.sms.message, this.sms.group)
      .then(() => {
        this.Notification.success(this.I18N.participant.smsSent);

        this.showSmsForm = false;
        this.sms = {
          group: 'ALL',
          message: null
        };
      });
  }

  action(url) {
    if (url) {
      this.eventService.eventAction(url)
        .then(() => {
          this.loadConfirmed();
          this.loadUnconfirmed();
        });
    } else {
      this.Notification.error(this.I18N.general.systemError);
    }
  }

  delete(url) {
    if (url) {
      this.eventService.delete(url)
        .then(() => {
          this.loadConfirmed();
          this.loadUnconfirmed();
        });
    } else {
      this.Notification.error(this.I18N.general.systemError);
    }
  }

  export() {
    this.reportService.availableColumns('participants')
      .then((resp) => {
        if (resp && resp.data) {
          this.reportService.download('participants', {
            format: 'XLS',
            columns: resp.data.map(data => data.key).join(','),
            eventNumber: this.number
          });
        }
      });
  }

  remove(url) {
    if (url) {
      swal({
        title: 'Bekreft kansellering',
        showCancelButton: true,
        confirmButtonColor: '#970b0e',
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nei',
        closeOnConfirm: false,
        showLoaderOnConfirm: true
      }, (answer) => {
        if (answer) {
          swal.close();
          this.action(url);
        }
      });
    }
  }

  deleteParticipants() {
    swal({
      title: 'Bekreft sletting av deltagerne',
      text: 'Obs! Deltagerdataene vil ikke kunne gjenopprettes',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: false,
      showLoaderOnConfirm: true
    }, (answer) => {
      if (answer) {
        swal.close();
        this.delete(this.event._links.participants.uri);
      }
    });
  }

  deleteParticipantsAndRecipients() {
    swal({
      title: 'Bekreft sletting av deltagerne',
      text: 'Obs! Deltagerdataene vil ikke kunne gjenopprettes',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: false,
      showLoaderOnConfirm: true
    }, (answer) => {
      if (answer) {
        swal.close();
        this.delete(this.event._links.participants.uri + 'WithRecipients');
      }
    });
  }
}

ParticipantList.$inject = ['$routeParams', 'eventService', 'reportService', 'I18N', 'Notification'];

const participantList = {
  controller: ParticipantList,
  templateUrl: 'event/participants.html'
};

angular
  .module('SendRegning')
  .component('participantList', participantList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/vert/:number/deltagere', {
        title: 'Deltagere',
        template: '<participant-list />',
        secure: true
      });
  });
